export const SERVICES = [
  {
    key: "co2",
    name: "CO2 Fractional Laser",
    tagline: "Resurface. Renew. Restore.",
    startingAt: "$250",
    image:
      "https://images.unsplash.com/photo-1741936362056-d9931fbdc148?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHx3b21hbiUyMGNsZWFyJTIwc2tpbiUyMGx1eHVyeSUyMGJlYXV0eXxlbnwwfHx8fDE3ODU2OTc5Mzh8MA&ixlib=rb-4.1.0&q=85",
    treatments: [
      "Skin rejuvenation",
      "Fine & deep wrinkle treatment",
      "Acne scars",
      "Hyperpigmented scars",
      "Surgical & burn scars",
      "Stretch marks removal",
      "Skin tightening",
      "Vaginal rejuvenation & tightening",
      "Urinary incontinence",
      "Warts & fungi treatment",
      "Skin tags & moles removal",
    ],
  },
  {
    key: "ipl",
    name: "IPL Photofacial",
    tagline: "Light that reveals radiance.",
    startingAt: "$250",
    image:
      "https://images.unsplash.com/photo-1668596808908-ac4d45963462?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHx3b21hbiUyMGNsZWFyJTIwc2tpbiUyMGx1eHVyeSUyMGJlYXV0eXxlbnwwfHx8fDE3ODU2OTc5Mzh8MA&ixlib=rb-4.1.0&q=85",
    treatments: [
      "Hair reduction — blond, red, gray & white hair",
      "Facial & baby hair reduction",
      "Spider & vascular veins removal",
      "Pigmentation — freckles, melasma, age & sun spots",
      "Rosacea treatment for sensitive skin",
      "Acne & active acne treatment",
      "Skin rejuvenation",
    ],
  },
  {
    key: "cupping",
    name: "Cupping Therapy",
    tagline: "Ancient ritual, modern glow.",
    startingAt: "$30",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_glow-lab-5/artifacts/bima6qhe_image.png",
    gallery: [
      "https://customer-assets-rejwkqb3.emergentagent.net/job_glow-lab-5/artifacts/bima6qhe_image.png",
      "https://images.unsplash.com/photo-1745327883389-17150e99dcf7?w=600&q=80",
      "https://images.unsplash.com/photo-1621287424405-a34be1c3ff7c?w=600&q=80",
      "https://images.unsplash.com/photo-1740689593879-b44e3eeaef31?w=600&q=80",
    ],
    treatments: ["Wet cupping", "Dry cupping", "Moving cupping"],
  },
  {
    key: "prp",
    name: "PRP Therapy",
    tagline: "Your body's own healing, amplified.",
    startingAt: "$375",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_glow-lab-5/artifacts/q0jbhdhp_image.png",
    treatments: [
      "Skin texture & tone improvement",
      "Fine line reduction",
      "Acne scar softening",
      "Natural collagen stimulation",
      "Hair restoration — thicker, stronger growth",
      "Overall skin rejuvenation",
    ],
  },
  {
    key: "iv",
    name: "IV Hydration Therapy",
    tagline: "Wellness, infused.",
    startingAt: "$150",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_glow-lab-5/artifacts/fwxbivba_image.png",
    treatments: [
      "Vitamin & nutrient replenishment",
      "Energy boost & fatigue relief",
      "Immune system support",
      "Deep cellular hydration",
      "Athletic & post-illness recovery",
      "Custom-tailored to your wellness goals",
    ],
  },
  {
    key: "weight",
    name: "Weight Management",
    tagline: "Sustainable transformation, medically guided.",
    startingAt: "$150",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_glow-lab-5/artifacts/z4l1gznx_image.png",
    treatments: [
      "Personal medical evaluation",
      "Customized treatment plan",
      "Nutritional guidance",
      "Lifestyle & habit coaching",
      "GLP-1 medications (when appropriate)",
      "Long-term, sustainable weight loss",
    ],
  },
  {
    key: "meso",
    name: "Mesotherapy",
    tagline: "Nutrients where your skin needs them most.",
    startingAt: "$200",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_glow-lab-5/artifacts/7lp2rbm6_image.png",
    treatments: [
      "Custom vitamin & amino-acid infusions",
      "Improved skin hydration & elasticity",
      "Fine line reduction",
      "Cellulite improvement",
      "Localized fat reduction",
      "Support for hair thinning",
    ],
  },
  {
    key: "hifu",
    name: "HIFU Skin Lifting",
    tagline: "Non-surgical lift. Zero downtime.",
    startingAt: "$500",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_glow-lab-5/artifacts/gjyzkoee_image.png",
    treatments: [
      "Face lifting & firming",
      "Neck & jawline definition",
      "Body skin tightening",
      "Deep collagen stimulation",
      "Reduction of sagging & fine lines",
      "Gradual, natural-looking results",
    ],
  },
  {
    key: "hydra",
    name: "Hydra-Beauty Facial",
    tagline: "Deep skincare ritual for face & neck.",
    startingAt: "$150",
    image:
      "https://images.unsplash.com/photo-1620331311520-246422fd82f9?w=1200&q=80",
    treatments: [
      "Deep pore cleansing",
      "Hydration & exfoliation",
      "Face & neck rejuvenation",
      "Post-facial glow",
    ],
  },
];

// Pricing catalog. All amounts in USD.
// Package discount policy: 3-session package = 20% off · 5-session package = 30% off (applied to base × N).
// Each block: columns[] = table headers, rows[] with { area, prices: [] } aligned to columns.
// Optional row.duration (extra right column). Optional row.savings (badge on last price).
const PKG3 = 0.80; // 20% off
const PKG5 = 0.70; // 30% off
const pkg3 = (base) => Math.round(base * 3 * PKG3);
const pkg5 = (base) => Math.round(base * 5 * PKG5);
const savings3 = (base) => Math.round(base * 3 * (1 - PKG3));
const savings5 = (base) => Math.round(base * 5 * (1 - PKG5));
// For treatments where savings needs to be shown, always highlight the 5-session (biggest) tier.
const PKG_COLS = ["1 session", "3-session package (20% off)", "5-session package (30% off)"];

export const PRICING = [
  {
    key: "co2-skin",
    name: "CO2 Fractional Laser — Skin Treatment",
    subtitle: "Targeting acne scars, wrinkles, and skin rejuvenation.",
    columns: PKG_COLS,
    rows: [
      { area: "Medium area (Face, neck, hands, or equivalent area)",
        prices: [600, pkg3(600), pkg5(600)], savings: savings5(600) },
      { area: "Big area (Face & neck, full abdomen, or stretch marks)",
        prices: [800, pkg3(800), pkg5(800)], savings: savings5(800) },
    ],
  },
  {
    key: "co2-vaginal",
    name: "CO2 Fractional Laser — Vaginal Tightening",
    columns: PKG_COLS,
    rows: [
      { area: "Vaginal treatment",
        prices: [1000, pkg3(1000), pkg5(1000)], savings: savings5(1000) },
    ],
  },
  {
    key: "co2-pulsed",
    name: "CO2 Fractional Laser — Pulsed Mode",
    subtitle: "Targeting warts, skin tags, fungi, and mole removal.",
    columns: PKG_COLS,
    rows: [
      { area: "Small procedures",
        prices: [250, pkg3(250), pkg5(250)], savings: savings5(250) },
    ],
  },
  {
    key: "ipl",
    name: "IPL Photofacial",
    subtitle: "Intense Pulsed Light — pigmentation, redness, hair reduction.",
    columns: PKG_COLS,
    rows: [
      { area: "Small (face, neck, or hands only)",
        prices: [250, pkg3(250), pkg5(250)], savings: savings5(250), duration: "30 min" },
      { area: "Medium (face & neck, shoulders, chest, lower arms, or hands)",
        prices: [500, pkg3(500), pkg5(500)], savings: savings5(500), duration: "45 min" },
    ],
  },
  {
    key: "hifu",
    name: "HIFU — Lift & Fat Reduction",
    subtitle: "Non-surgical ultrasound lifting and fat reduction.",
    columns: PKG_COLS,
    rows: [
      { area: "Medium area — Face",
        prices: [500, pkg3(500), pkg5(500)], savings: savings5(500) },
      { area: "Big area — Face & neck",
        prices: [700, pkg3(700), pkg5(700)], savings: savings5(700) },
      { area: "Fat reduction — Abdomen, back, love handles",
        prices: [800, pkg3(800), pkg5(800)], savings: savings5(800) },
    ],
  },
  {
    key: "hydra",
    name: "Hydra-Beauty Facial",
    subtitle: "Skin care and face & neck facial ritual.",
    columns: PKG_COLS,
    rows: [
      { area: "Face cleaning (face & neck)",
        prices: [150, pkg3(150), pkg5(150)], savings: savings5(150) },
    ],
  },
  {
    key: "cupping",
    name: "Cupping Therapy",
    subtitle: "Traditional wet, dry & moving cupping (Hijama). Same 20% / 30% package discount applies.",
    columns: ["30-minute session", "60–90-minute comprehensive"],
    rows: [
      { area: "Dry Cupping", prices: ["$30 – $45", "$110 – $185"] },
      { area: "Moving Cupping", prices: ["$30 – $45", "$110 – $185"] },
      { area: "Wet Cupping (Hijama)", prices: ["$120 – $250", "$120 – $250"] },
    ],
  },
  {
    key: "prp",
    name: "PRP Therapy — Platelet-Rich Plasma",
    subtitle: "PRP facial rejuvenation and hair restoration. Package pricing reflects 20% / 30% discount.",
    columns: ["1 session", "3-session package (20% off)", "5-session package (30% off)"],
    rows: [
      { area: "PRP Facial", prices: ["$375 – $400", "$900 – $960", "$1,313 – $1,400"] },
      { area: "PRP Hair Restoration", prices: ["$375 – $400", "$900 – $960", "$1,313 – $1,400"] },
    ],
  },
  {
    key: "iv",
    name: "IV Hydration Therapy",
    subtitle: "Custom vitamin & nutrient infusions. Package pricing reflects 20% / 30% discount.",
    columns: ["1 session", "3-session package (20% off)", "5-session package (30% off)"],
    rows: [
      { area: "Standard Drips (Myers' Cocktail / Immunity)",
        prices: ["$150 – $250", "$360 – $600", "$525 – $875"] },
      { area: "Premium Drips (NAD+ Therapy — dosage dependent)",
        prices: ["$500 – $800", "$1,200 – $1,920", "$1,750 – $2,800"] },
    ],
  },
  {
    key: "weight",
    name: "Weight Management (GLP-1 Program)",
    subtitle: "Medically-guided sustainable weight loss.",
    columns: ["Price"],
    rows: [
      { area: "Initial Medical Consultation (eligibility evaluation)", prices: ["$150 – $350"] },
      { area: "Monthly Medical Weight Loss — Semaglutide or Tirzepatide", prices: ["$350 – $600 / month"] },
    ],
  },
  {
    key: "meso",
    name: "Mesotherapy",
    subtitle: "Micro-injections of vitamins, amino acids & exosomes. Package pricing reflects 20% / 30% discount.",
    columns: ["1 session", "3-session package (20% off)", "5-session package (30% off)"],
    rows: [
      { area: "Standard Vitamin / Lipolytic Infusions",
        prices: ["$200 – $400", "$480 – $960", "$700 – $1,400"] },
      { area: "Exosomal Mesotherapy (Advanced Anti-Aging)",
        prices: ["$650+", "$1,560+", "$2,275+"] },
    ],
  },
  {
    key: "consult",
    name: "Free Consultation",
    subtitle: "30 minutes with our team — treatment planning.",
    free: true,
  },
];

export const PARAMETERS = [
  { name: "RGB Pore Analysis", desc: "Assesses pore size, distribution, and congestion." },
  { name: "RGB Spot Detection", desc: "Identifies visible pigmentation and discoloration." },
  { name: "RGB Wrinkle Analysis", desc: "Evaluates fine lines and wrinkle depth." },
  { name: "PL Texture Analysis", desc: "Examines skin smoothness and surface uniformity." },
  { name: "UV Porphyrin Detection", desc: "Detects bacterial activity within pores." },
  { name: "UV Pigmentation Analysis", desc: "Reveals subsurface pigmentation unseen to the eye." },
  { name: "UV Moisture Assessment", desc: "Evaluates hydration levels and barrier function." },
  { name: "Sensitive Area Mapping", desc: "Identifies regions prone to irritation & inflammation." },
  { name: "Brown Area Analysis", desc: "Measures melanin concentration and density." },
  { name: "UV Damage Assessment", desc: "Detects photodamage caused by sun exposure." },
  { name: "Skin Aging Analysis", desc: "Assesses overall aging indicators & condition." },
  { name: "Skin Beautification Simulation", desc: "Visualizes potential treatment outcomes." },
];
